import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';



export const StyledToolbarGrid = styled(Grid)`
    && {
        flex: 0 0 auto;
    }
`